var r=/^[1-9]\d{1,17}$/;export{r as PHONE_NUMBER_PATTERN};
//# sourceMappingURL=validations.constants.js.map
